import React, { useState } from "react";
import "./LiveChatWidget.css";

function LiveChatWidget() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { from: "bot", text: "Hi 👋 Welcome to African Store. How can I help you?" }
  ]);
  const [input, setInput] = useState("");

  const autoReply = (msg) => {
    msg = msg.toLowerCase();

    if (msg.includes("price")) return "All prices depend on product and country selection 💰";
    if (msg.includes("delivery")) return "Delivery takes 3-7 working days 🚚";
    if (msg.includes("return")) return "You can return products within 7 days 🔁";
    if (msg.includes("contact")) return "You can contact us on WhatsApp anytime 📞";
    if (msg.includes("payment")) return "We accept UPI, PayPal, Cards and NetBanking 💳";

    return "Thanks for your message 😊 Our team will reply soon.";
  };

  const sendMessage = () => {
    if (!input.trim()) return;

    const userMsg = { from: "user", text: input };
    const botMsg = { from: "bot", text: autoReply(input) };

    setMessages([...messages, userMsg, botMsg]);
    setInput("");
  };

  return (
    <>
      <div className="chat-float">
        <button className="chat-btn" onClick={() => setOpen(!open)}>💬</button>

        {/* <a
          href="https://wa.me/911234567890"
          target="_blank"
          rel="noreferrer"
          className="whatsapp-btn"
        >
          <i class="fab fa-whatsapp"></i>
        </a> */}
      </div>

      {open && (
        <div className="chat-popup">
          <div className="chat-header">
            <span>Live Support</span>
            <button onClick={() => setOpen(false)}>✖</button>
          </div>

          <div className="chat-body">
            {messages.map((m, i) => (
              <div key={i} className={m.from}>
                {m.text}
              </div>
            ))}
          </div>

          <div className="chat-footer">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Type message..."
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />
            <button onClick={sendMessage}>Send</button>
          </div>
        </div>
      )}
    </>
  );
}

export default LiveChatWidget;
